var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('SelectBox',{attrs:{"placeholder":_vm.$t('reporting.commonLabels.period'),"value":_vm.value,"options":_vm.periods},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }